module.exports = __webpack_public_path__ + "static/img/nowPolicejiejing.2e7186c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nowPolicejiejing.png
// module id = HMqL
// module chunks = 208